import * as MODULES from '../module-codes'
import axios from 'axios'

export const state = () => ({
    title: '',
    tweets: [],
    tweetsRead: [],
    tweetsUnread: [],
    messageStyle: "twitter",
    fetched: false
})

export const getters = {
    title: state => state.title,
    tweetsRead: state => state.tweetsRead,
    tweetsUnread: state => state.tweetsUnread,
    messageStyle: state => state.messageStyle,
    fetched: state => state.fetched
}

export const actions = {
    readTweet:  async ({ commit, dispatch }, payload) => {
        commit("READ_TWEET", payload)
        dispatch("updateModuleInDB")
    },
    updateModuleInDB: async ({ state, rootState }) => {
        let content = {
            tweetsRead: state.tweetsRead,
            tweetsUnread: state.tweetsUnread
        }
        await axios.post('/api/updateModule', {
            params: {
                moduleState: content,
                moduleName: MODULES.FEED,
                pcs: localStorage.getItem('pcs'),
                classId: rootState.auth.classId,
            } 
        })
    },
    populateFeedFromDB: async ({ commit, dispatch, rootGetters }) => {
        axios.post('/api/pcs/feed', {
            params: {
                pcs: localStorage.getItem('pcs')
            }
        }).then( async res => {
            await dispatch("events/computeCurrentPhase", {}, { root: true });
            res.data['settings'].currentphase = rootGetters['events/currentPhase']
            commit("SET_FEED_MODULE_DATA", res.data['settings'])
        })
    },
    populateFromDB: async ({ commit, dispatch }, payload) => {
        dispatch('populateFeedFromDB')
        if (payload) {
            commit('SET_FEED_USER_CONTENT', payload)
        }
    },
}

export const mutations = {
    SET_FEED_MODULE_DATA(state, payload) {
        state.title = payload.title
        state.tweets = payload.tweets
        state.messageStyle = payload.messageStyle ?? "twitter"
        if(state.tweetsUnread.length === 0 && state.tweetsRead.length === 0){
            payload.tweets.forEach(tweet => {
                if (tweet.done && tweet.day === (payload.currentphase + 1)) {
                    tweet.readAt = Date.now()
                    state.tweetsRead.push(tweet)
                }
                else {
                    state.tweetsUnread.push(tweet)
                }
            })
        }
        state.fetched = true
    },
    SET_FEED_USER_CONTENT(state, payload) {
        state.tweetsRead = payload.tweetsRead
        state.tweetsUnread = payload.tweetsUnread
        state.fetched = true
    },
    READ_TWEET(state, payload){
       let unreadIndex = payload
       let tweetToRead = state.tweetsUnread.splice(unreadIndex,1)
       tweetToRead[0].readAt = Date.now()
       state.tweetsRead.unshift(tweetToRead[0])
    }
}